import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppDispatch, RootState } from "src/store"
import { RemoveSection } from "@app/types/facilityTypes"
import { api } from "@app/api"
import { getBuildingsByCheckerboardThunk } from "src/slices/building-slice/thunks/get-buildings-by-checkerboard-thunk"
import { alertComponentShow } from "src/slices/alertComponentSlice"

export const removeSectionThunk = createAsyncThunk<void, RemoveSection, { dispatch: AppDispatch; state: RootState }>(
	"@@section/remove",
	async (data, { dispatch }) => {
		try {
			const text = await api.section.delete(data)
			dispatch(getBuildingsByCheckerboardThunk(undefined))
			dispatch(alertComponentShow({ severity: "success", text }))
		} catch (e) {
			console.log(e)
			const text = e?.response?.data?.error_message || "Что-то пошло не так..."
			dispatch(alertComponentShow({ severity: "error", text }))
			throw e
		}
	}
)

export function removeSectionThunkPending(state: RootState["sectionSlice"]) {
	state.removeSectionInProcess = true
}

export function removeSectionThunkRejected(state: RootState["sectionSlice"]) {
	state.removeSectionInProcess = false
}

export function removeSectionThunkFulfilled(state: RootState["sectionSlice"]) {
	state.removeSectionInProcess = false
}
